'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.queryMappedTranslations = exports.queryTranslations = exports.languageQuery = void 0;
var tslib_1 = require("tslib");
var magic_messages_1 = require("@gig/magic-messages");
function languageQuery() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.LANGUAGE_QUERY)];
                case 1: return [2 /*return*/, (_a.sent())];
            }
        });
    });
}
exports.languageQuery = languageQuery;
function queryTranslations() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.TRANSLATIONS_QUERY)];
                case 1: return [2 /*return*/, (_a.sent())];
            }
        });
    });
}
exports.queryTranslations = queryTranslations;
function queryMappedTranslations() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var translations;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, queryTranslations()];
                case 1:
                    translations = _a.sent();
                    return [2 /*return*/, translations.reduce(function (prev, curr) {
                            var _a;
                            return Object.assign(prev, (_a = {}, _a[curr.uniqID || curr.key] = curr.val, _a));
                        }, {})];
            }
        });
    });
}
exports.queryMappedTranslations = queryMappedTranslations;
